






































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';
import SearchBar from './searchBar.vue';
import SearchList from './searchList.vue';

@Component({
  components: {
    SearchBar,
    SearchList,
  },
})
export default class FitNation extends Vue {
  @Prop({ default: () => [] }) public data!: any[];
  @Prop({ default: () => [] }) public hotList!: any[];
  @Prop({ default: '' }) public placeholder!: string;
  @Prop({ default: false }) public show!: boolean;
  @Prop({ default: '热门' }) public hotListTitle!: string;
  @Prop({ default: '全部' }) public searchTitle!: string;
  @Prop({ default: '搜索' }) public searchPlaceholder!: string;
  @Prop({ default: '取消' }) public cancelText!: string;
  @Model('change') public readonly value!: string[] | number[];
  public query = '';
  public canSlide = true;
  get searchList() {
    if (this.query) {
      return this.data.filter(item => item.label.toLowerCase().indexOf(this.query.toLowerCase()) > -1);
    }
    return this.data;
  }
  get searchHotList() {
    if (this.query) {
      return [];
    }
    return this.hotList;
  }
  public onChange(value: any, item: any) {
    this.$emit('change', value, item);
  }
  public close() {
    this.$emit('close');
  }
  public getAppDomInstance() {
    return this.$root.$children[0].$el;
  }
  public toggleApp(value: boolean) {
    if (value) {
      // @ts-ignore
      this.getAppDomInstance().style.display = 'block';
    } else {
      // @ts-ignore
      this.getAppDomInstance().style.display = 'none';
    }
  }
  @Watch('show')
  public onShow() {
    if (this.show) {
      document.body.appendChild(this.$el);
      this.toggleApp(false);
    } else {
      this.toggleApp(true);
    }
  }
  public onPopState() {
    this.close();
  }
  public created() {
    window.addEventListener('popstate', this.onPopState, false);
  }
  public beforeDestroy() {
    window.removeEventListener('popstate', this.onPopState);
    if (this.$el) {
      document.body.removeChild(this.$el);
    }
  }
}
